import { isDefined, isNil } from "@clipboard-health/util-ts";
import { useWorkerStats } from "@src/appV2/Accounts/WorkplaceReferrals/api/useWorkerStats";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

export function hasWorkerSeenClipboardScoreEducation(): boolean {
  const seen = sessionStorage.getItem(`clipboard-score-education-seen`);
  return isDefined(seen);
}

export function markWorkerAsSeenClipboardScoreEducation() {
  sessionStorage.setItem(`clipboard-score-education-seen`, "true");
}

export function useShouldShowClipboardScoreEducation(workerPastShiftsCount: number | undefined) {
  const hasSeenClipboardScoreEducation = hasWorkerSeenClipboardScoreEducation();
  const { userId: workerId } = useDefinedWorker();

  // Fetch worker stats as fallback when workerPastShiftsCount is undefined
  const { data: workerStats } = useWorkerStats(
    { agentId: workerId },
    {
      enabled: isNil(workerPastShiftsCount) && !hasSeenClipboardScoreEducation,
    }
  );
  const resolvedPastShiftsCount = workerPastShiftsCount ?? workerStats?.completedShiftsCount;

  const shouldShowClipboardScoreEducation =
    isDefined(resolvedPastShiftsCount) &&
    resolvedPastShiftsCount === 0 &&
    !hasSeenClipboardScoreEducation;

  return {
    shouldShowClipboardScoreEducation,
  };
}
